export const COEFFICIENTS = {
  age: 0.0058,
  sex: -0.0401,
  nstemi: 0.2737,
  eGFR: -0.0025,
  hemo: -0.0006,
  albuminuriaMild: 0.0109,
  albuminuriaHEavy: 0.1093,
  charlsonCHF: 0.1103,
  charlsonCOPD: 0.0147,
  charlsonPVD: 0.0849,
  diabetes: 0.0886,
  priorInv: 0.3366
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 0.79
};
